import { render, staticRenderFns } from "./cmp-mdc-data-search-item.vue?vue&type=template&id=422ee25b&scoped=true&"
import script from "./cmp-mdc-data-search-item.vue?vue&type=script&lang=ts&"
export * from "./cmp-mdc-data-search-item.vue?vue&type=script&lang=ts&"
import style0 from "./cmp-mdc-data-search-item.vue?vue&type=style&index=0&id=422ee25b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422ee25b",
  null
  
)

/* custom blocks */
import block0 from "./cmp-mdc-data-search-item.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports